/**
 * 한국 주요 지역 경도 데이터.
 * 진태양시 보정에 사용할 수 있는 지역별 경도 + 상위 광역자치단체(province) 목록.
 */

export interface Region {
  /** 시·군·구 이름 (7개 광역단위는 자체 이름) */
  readonly name: string;
  /** 상위 광역자치단체 (광역시도) 이름 */
  readonly province: string;
  /** 동경 기준 경도 (°) */
  readonly longitude: number;
}

export const REGIONS: ReadonlyArray<Region> = [
  // 특별시·광역시·특별자치시
  { name: '서울', province: '서울특별시', longitude: 126.977902 },
  { name: '부산', province: '부산광역시', longitude: 129.075577 },
  { name: '대구', province: '대구광역시', longitude: 128.601734 },
  { name: '인천', province: '인천광역시', longitude: 126.705401 },
  { name: '대전', province: '대전광역시', longitude: 127.383316 },
  { name: '울산', province: '울산광역시', longitude: 129.311327 },
  { name: '세종', province: '세종특별자치시', longitude: 127.290757 },

  // 경기도
  { name: '고양', province: '경기도', longitude: 126.833811 },
  { name: '과천', province: '경기도', longitude: 126.987802 },
  { name: '광명', province: '경기도', longitude: 126.864602 },
  { name: '광주', province: '경기도', longitude: 127.255392 },
  { name: '구리', province: '경기도', longitude: 127.129522 },
  { name: '군포', province: '경기도', longitude: 126.933051 },
  { name: '김포', province: '경기도', longitude: 126.715633 },
  { name: '남양주', province: '경기도', longitude: 127.216442 },
  { name: '동두천', province: '경기도', longitude: 127.060407 },
  { name: '부천', province: '경기도', longitude: 126.765908 },
  { name: '성남', province: '경기도', longitude: 127.126627 },
  { name: '수원', province: '경기도', longitude: 127.028574 },
  { name: '시흥', province: '경기도', longitude: 126.802881 },
  { name: '안산', province: '경기도', longitude: 126.828954 },
  { name: '안성', province: '경기도', longitude: 127.279763 },
  { name: '안양', province: '경기도', longitude: 126.958697 },
  { name: '양주', province: '경기도', longitude: 127.045545 },
  { name: '양평', province: '경기도', longitude: 127.487557 },
  { name: '여주', province: '경기도', longitude: 127.637329 },
  { name: '연천', province: '경기도', longitude: 127.075183 },
  { name: '오산', province: '경기도', longitude: 127.077376 },
  { name: '용인', province: '경기도', longitude: 127.177933 },
  { name: '의왕', province: '경기도', longitude: 126.968299 },
  { name: '의정부', province: '경기도', longitude: 127.033679 },
  { name: '이천', province: '경기도', longitude: 127.435002 },
  { name: '파주', province: '경기도', longitude: 126.778317 },
  { name: '평택', province: '경기도', longitude: 127.095997 },
  { name: '포천', province: '경기도', longitude: 127.200344 },
  { name: '하남', province: '경기도', longitude: 127.214926 },
  { name: '화성', province: '경기도', longitude: 126.828594 },

  // 강원특별자치도
  { name: '강릉', province: '강원특별자치도', longitude: 128.876055 },
  { name: '고성', province: '강원특별자치도', longitude: 128.467817 },
  { name: '동해', province: '강원특별자치도', longitude: 129.114259 },
  { name: '삼척', province: '강원특별자치도', longitude: 129.164749 },
  { name: '속초', province: '강원특별자치도', longitude: 128.591862 },
  { name: '양구', province: '강원특별자치도', longitude: 127.989824 },
  { name: '양양', province: '강원특별자치도', longitude: 128.619038 },
  { name: '영월', province: '강원특별자치도', longitude: 128.461848 },
  { name: '원주', province: '강원특별자치도', longitude: 127.919641 },
  { name: '인제', province: '강원특별자치도', longitude: 128.170699 },
  { name: '정선', province: '강원특별자치도', longitude: 128.660749 },
  { name: '철원', province: '강원특별자치도', longitude: 127.313317 },
  { name: '춘천', province: '강원특별자치도', longitude: 127.732695 },
  { name: '태백', province: '강원특별자치도', longitude: 128.985544 },
  { name: '평창', province: '강원특별자치도', longitude: 128.390016 },
  { name: '홍천', province: '강원특별자치도', longitude: 127.888843 },
  { name: '화천', province: '강원특별자치도', longitude: 127.708187 },
  { name: '횡성', province: '강원특별자치도', longitude: 127.984965 },

  // 충청북도
  { name: '단양', province: '충청북도', longitude: 128.365431 },
  { name: '보은', province: '충청북도', longitude: 127.729418 },
  { name: '영동', province: '충청북도', longitude: 127.783388 },
  { name: '옥천', province: '충청북도', longitude: 127.571342 },
  { name: '음성', province: '충청북도', longitude: 127.690523 },
  { name: '제천', province: '충청북도', longitude: 128.190894 },
  { name: '증평', province: '충청북도', longitude: 127.581489 },
  { name: '진천', province: '충청북도', longitude: 127.435618 },
  { name: '청주', province: '충청북도', longitude: 127.488753 },
  { name: '충주', province: '충청북도', longitude: 127.925918 },

  // 충청남도
  { name: '공주', province: '충청남도', longitude: 127.118999 },
  { name: '금산', province: '충청남도', longitude: 127.48811 },
  { name: '논산', province: '충청남도', longitude: 127.09866 },
  { name: '당진', province: '충청남도', longitude: 126.64444 },
  { name: '보령', province: '충청남도', longitude: 126.612737 },
  { name: '부여', province: '충청남도', longitude: 126.909789 },
  { name: '서산', province: '충청남도', longitude: 126.450288 },
  { name: '서천', province: '충청남도', longitude: 126.691343 },
  { name: '아산', province: '충청남도', longitude: 127.002034 },
  { name: '예산', province: '충청남도', longitude: 126.848697 },
  { name: '천안', province: '충청남도', longitude: 127.113745 },
  { name: '청양', province: '충청남도', longitude: 126.802238 },
  { name: '태안', province: '충청남도', longitude: 126.298004 },
  { name: '홍성', province: '충청남도', longitude: 126.660729 },

  // 전북특별자치도
  { name: '군산', province: '전북특별자치도', longitude: 126.736756 },
  { name: '김제', province: '전북특별자치도', longitude: 126.880387 },
  { name: '남원', province: '전북특별자치도', longitude: 127.390381 },
  { name: '무주', province: '전북특별자치도', longitude: 127.660829 },
  { name: '부안', province: '전북특별자치도', longitude: 126.733444 },
  { name: '순창', province: '전북특별자치도', longitude: 127.137571 },
  { name: '완주', province: '전북특별자치도', longitude: 127.162202 },
  { name: '익산', province: '전북특별자치도', longitude: 126.957174 },
  { name: '임실', province: '전북특별자치도', longitude: 127.289179 },
  { name: '장수', province: '전북특별자치도', longitude: 127.520772 },
  { name: '전주', province: '전북특별자치도', longitude: 127.147958 },
  { name: '정읍', province: '전북특별자치도', longitude: 126.855942 },
  { name: '진안', province: '전북특별자치도', longitude: 127.424838 },

  // 전남광주통합특별시 (2026-07-01 전라남도 + 광주광역시 통합, 법률 제21446호)
  { name: '고흥', province: '전남광주통합특별시', longitude: 127.281928 },
  { name: '곡성', province: '전남광주통합특별시', longitude: 127.292013 },
  { name: '광양', province: '전남광주통합특별시', longitude: 127.695985 },
  { name: '광주', province: '전남광주통합특별시', longitude: 126.851338 },
  { name: '구례', province: '전남광주통합특별시', longitude: 127.462746 },
  { name: '나주', province: '전남광주통합특별시', longitude: 126.710772 },
  { name: '담양', province: '전남광주통합특별시', longitude: 126.988504 },
  { name: '목포', province: '전남광주통합특별시', longitude: 126.391914 },
  { name: '무안', province: '전남광주통합특별시', longitude: 126.481621 },
  { name: '보성', province: '전남광주통합특별시', longitude: 127.080068 },
  { name: '순천', province: '전남광주통합특별시', longitude: 127.487356 },
  { name: '신안', province: '전남광주통합특별시', longitude: 126.350478 },
  { name: '여수', province: '전남광주통합특별시', longitude: 127.662242 },
  { name: '영광', province: '전남광주통합특별시', longitude: 126.512011 },
  { name: '영암', province: '전남광주통합특별시', longitude: 126.696714 },
  { name: '완도', province: '전남광주통합특별시', longitude: 126.755129 },
  { name: '장성', province: '전남광주통합특별시', longitude: 126.784822 },
  { name: '장흥', province: '전남광주통합특별시', longitude: 126.907103 },
  { name: '진도', province: '전남광주통합특별시', longitude: 126.263508 },
  { name: '함평', province: '전남광주통합특별시', longitude: 126.516691 },
  { name: '해남', province: '전남광주통합특별시', longitude: 126.599304 },
  { name: '화순', province: '전남광주통합특별시', longitude: 126.986636 },

  // 경상북도
  { name: '경주', province: '경상북도', longitude: 129.224739 },
  { name: '고령', province: '경상북도', longitude: 128.262917 },
  { name: '구미', province: '경상북도', longitude: 128.344284 },
  { name: '군위', province: '경상북도', longitude: 128.572905 },
  { name: '김천', province: '경상북도', longitude: 128.113661 },
  { name: '문경', province: '경상북도', longitude: 128.186711 },
  { name: '봉화', province: '경상북도', longitude: 128.7325 },
  { name: '상주', province: '경상북도', longitude: 128.158992 },
  { name: '성주', province: '경상북도', longitude: 128.282954 },
  { name: '안동', province: '경상북도', longitude: 128.729591 },
  { name: '영덕', province: '경상북도', longitude: 129.366139 },
  { name: '영양', province: '경상북도', longitude: 129.112401 },
  { name: '영주', province: '경상북도', longitude: 128.624024 },
  { name: '영천', province: '경상북도', longitude: 128.938572 },
  { name: '예천', province: '경상북도', longitude: 128.452611 },
  { name: '울릉', province: '경상북도', longitude: 130.905883 },
  { name: '울진', province: '경상북도', longitude: 129.400575 },
  { name: '의성', province: '경상북도', longitude: 128.697013 },
  { name: '청도', province: '경상북도', longitude: 128.733845 },
  { name: '청송', province: '경상북도', longitude: 129.057016 },
  { name: '칠곡', province: '경상북도', longitude: 128.401744 },
  { name: '포항', province: '경상북도', longitude: 129.343626 },

  // 경상남도
  { name: '거창', province: '경상남도', longitude: 127.90959 },
  { name: '김해', province: '경상남도', longitude: 128.889328 },
  { name: '남해', province: '경상남도', longitude: 127.892531 },
  { name: '밀양', province: '경상남도', longitude: 128.746946 },
  { name: '사천', province: '경상남도', longitude: 128.06388 },
  { name: '산청', province: '경상남도', longitude: 127.873438 },
  { name: '양산', province: '경상남도', longitude: 129.037015 },
  { name: '의령', province: '경상남도', longitude: 128.261724 },
  { name: '진주', province: '경상남도', longitude: 128.10783 },
  { name: '창녕', province: '경상남도', longitude: 128.492272 },
  { name: '창원', province: '경상남도', longitude: 128.682366 },
  { name: '통영', province: '경상남도', longitude: 128.433188 },
  { name: '하동', province: '경상남도', longitude: 127.750581 },
  { name: '함안', province: '경상남도', longitude: 128.406481 },
  { name: '함양', province: '경상남도', longitude: 127.725165 },
  { name: '합천', province: '경상남도', longitude: 128.165883 },

  // 제주특별자치도
  { name: '제주', province: '제주특별자치도', longitude: 126.53747 },
];
